import { IEmailAttachmentCreation } from "../../../interfaces/IEmailAttachmentCreation";
import { ModeEnum } from "../../enums/modeEnum";
import { AddEmailer } from "./AddEmailer";
import { CreateEmailer } from "./CreateEmailer";

export class EmailCreatorFactory {
  constructor(private isOrganization: boolean) { }
  create(languageStrings: any, mode: ModeEnum): IEmailAttachmentCreation {
    return mode === ModeEnum.mailRead ? new CreateEmailer(this.isOrganization) : new AddEmailer(languageStrings, this.isOrganization);
  }
}
